module.exports = __webpack_public_path__ + "img/satoshi-gold.05441ad1.svg";